import { gql } from '@apollo/client';

export const ADD_SCAN_SESSION = gql`
    mutation AddScanSession($scanSession: ScanSessionInputGraph!) {
        addScanSession(scanSession: $scanSession) {
            id
            created
            containerAsset {
                id
                name
                leafFolderPath
            }
            containerFolder {
                id
                name
                path
            }
        }
    }
`;

export const ADD_SCAN = gql`
    mutation AddScan($scan: ScanInputGraph!) {
        addScan(scan: $scan) {
            tagNumber
            timestamp
            status
            succeeded
            scan {
                id
                tagNumber
                antenna
                scanned
                asset {
                    id
                    name
                    tagNumber
                    displayImageId
                }
            }
        }
    }
`;
